export default {
  apiKey: "AIzaSyDDo9VbbqdB1B3LVJN7qa3JMgRxXQwSKGs",
  authDomain: "doctor365-9a68d.firebaseapp.com",
  projectId: "doctor365-9a68d",
  storageBucket: "doctor365-9a68d.appspot.com",
  messagingSenderId: "41805375326",
  appId: "1:41805375326:web:3e8e38cecd075875cd91cf",
  measurementId: "G-7S1ZXH1HX9"
};
